/**
 * OAuth Utilities (Frontend/Pickem)
 *
 * Thin wrapper around shared OAuth utils from @low6-pickem/sports-config.
 * Provides app-specific config (API URL, tenant slug) so callers
 * can continue to call initiateOAuthLogin() with no arguments.
 */

import {
  initiateOAuthLogin as sharedInitiateOAuthLogin,
  resolveTenantFromUrl,
} from '@low6-pickem/frontend-shared';

// Re-export shared utils directly
export {
  generateOAuthState,
  storeOAuthState,
  retrieveOAuthState,
  extractOAuthParams,
  isOAuthCallback,
} from '@low6-pickem/frontend-shared';

const API_BASE_URL =
  import.meta.env.VITE_PREPLAY_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:3001';

/** Initiate OAuth login with app-specific config */
export async function initiateOAuthLogin(): Promise<void> {
  return sharedInitiateOAuthLogin(API_BASE_URL, resolveTenantFromUrl());
}
